import { Storage } from '@ionic/storage';

class StorageService {
  constructor(private storage: Storage) {
    this.storage = storage;
    this.init().then();
  }

  private init = () => this.storage.create();

  getData = (key: string) => this.storage.get(key);

  addData = (key: string, value: any) => this.storage.set(key, value);

  removeData = (key: string) => this.storage.remove(key);

  clear = () => this.storage.clear();

  setEncryptionKey = (key: string) => this.storage.setEncryptionKey(key);

  keys = () => this.storage.keys();
}

export default StorageService;
